import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { PhoneIcon } from "@gemini/icons";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { IS_SERVER } from "@/constants";
import { useCustomerAction, useTrackingLeadInterestPhone, } from "@/hooks/tracking";
import { useClassifiedAnalytics } from "@/hooks/tracking/classifiedAnalytics";
import { useTrackingLegacyLeadEvents } from "@/hooks/tracking/trackingLegacy";
import { CA_EVENT_TYPES } from "@/types/classifiedAnalytics";
import { useClassified } from "@/contexts/classified";
import { CallTrackingStatus, useCallTracking } from "@/contexts/callTracking";
export const callButtonTestId = "cdp-contacting-call-button";
export const CallButton = ({ label, tracking, isFullWidth = true, variant = "primary", phoneNumber, iconOnly = false, }) => {
    var _a;
    const isPreviewMode = useIsPreviewMode();
    const { fetchCallTrackingData, virtualPhoneNumbers, status: callTrackingStatus, } = useCallTracking();
    const handleCallTracking = () => {
        if (callTrackingStatus === CallTrackingStatus.IDLE) {
            fetchCallTrackingData();
        }
    };
    const { customerActionExposeContactPhoneView, customerActionExposeContactPhoneCall, } = useCustomerAction();
    const { legacyLeadConversionPhone } = useTrackingLegacyLeadEvents(); // Legacy GA3 for harvest
    const legacyTrackingData = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.legacyTracking;
    const trackLeadPhoneInterestEvent = useTrackingLeadInterestPhone(tracking.avZone);
    const { sendClassifiedAnalyticsEvent } = useClassifiedAnalytics();
    const handleLegacyTracking = () => {
        const hasTrackingData = !!legacyTrackingData;
        if (hasTrackingData) {
            legacyLeadConversionPhone({
                eventData: { infos: tracking.legacy },
            });
        }
    };
    const handleTracking = () => {
        customerActionExposeContactPhoneView(); // germany
        customerActionExposeContactPhoneCall(); // germany
        trackLeadPhoneInterestEvent(); // WL tracking
        sendClassifiedAnalyticsEvent(CA_EVENT_TYPES.PHONE_NUMBER_DISPLAY); // classified analytics
        handleLegacyTracking(); // Legacy GA3 for harvest
    };
    const handleOnPress = () => {
        if (IS_SERVER)
            return;
        handleTracking();
        handleCallTracking();
        const callNumber = (virtualPhoneNumbers === null || virtualPhoneNumbers === void 0 ? void 0 : virtualPhoneNumbers[0]) || phoneNumber;
        // eslint-disable-next-line no-restricted-globals
        window.location.href = `tel:${callNumber}`;
    };
    return (_jsx(Button, { variant: variant, isFullWidth: isFullWidth, icon: PhoneIcon, isDisabled: isPreviewMode, onPress: handleOnPress, iconOnly: iconOnly, testId: callButtonTestId, children: label }));
};
